export default {"src":"/_next/static/image/public/images/flags/flag_20.441e8b798c3258acf8b2758d03b819f9.svg","height":16,"width":25};